<div class="fullcontainer">
    <div class="sheet">
      <h1 class='header'>Job ID: {{ this.job.id }}</h1>
  
      <p>Are you sure you wish to delete this job? This will remove the job from any timelines. If you wish for this to be restored. Please contact support..</p>
  
        
      <button type="submit" class="btn btn-danger" (click)='this.onCancelClicked()'>Yes! I'm Sure!</button>&nbsp;
      <button type="button" class="btn btn-primary" routerLink='/job-signoff/land'>No! Take me back!</button>
    </div>
  </div>
  